/**
 * Da formato a un numero recibido en formato XXX,XXX.XX,
 * si se recibe currency, se concatena al final separado con un espacio
 * @param string amount ejem. 1999.9967575
 * @returns string ejem. 1,999.99
 */
const formatAmount = (amount) => {
  try {
    // limpiamos la cadena, si se recibe amount con formato, para no retornar un numero erróneo
    const monto = String(amount).replaceAll(",", "");

    // si el valor recibido no es un numero entero o flotante
    if (!/^\d*\.?\d+$/.test(monto)) {
        // retornamos el valor recibido, sin cambios
        return amount;
    }

    let amountFormatResult = parseFloat(monto).toLocaleString("es-MX", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return amountFormatResult;
  } catch (error) {
    console.error(error);
    return amount;
  }
};

export default formatAmount;
